export const queryString = {
	decode(value: string | null): any {
		if (!value) { return {}; }
		return value
			.split('&')
			.reduce((acc, item) => {
				const [key, value] = item.split('=');
				return { ...acc, [key]: value };
			}, {});
	},
	encode(obj: Record<string, any>) {
		return Object
			.entries(obj)
			.map(([key, value]) => [key, value].join('='))
			.join('&');
	},
};
